module.exports = __webpack_public_path__ + "img/Shiba-BG.d2b2bf08.jpg";